import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@mui/material';
import { Tag } from '@/components/tag';
import { dataClassLabel } from '@/data/inventory/dataClassifications';
import { useClassificationCategories } from '@/data/inventory/useClassificationCategories';
export function DataClassTag(t0) {
  const $ = _c(7);
  const {
    name
  } = t0;
  const {
    lookup
  } = useClassificationCategories();
  const t1 = lookup[name]?.description ?? lookup[name]?.title ?? name;
  let t2;
  if ($[0] !== name) {
    t2 = dataClassLabel(name);
    $[0] = name;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <Tag content={t2} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t3) {
    t4 = <Tooltip title={t1}>{t3}</Tooltip>;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}